/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header>
      <ion-toolbar
        color="primary"
        class="home-statusbar"
        style="height: 0px"
      ></ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="false" class="" color="primary">
      <div
        :class="{
          sticky: stickyToolbar,
          'background-grey': instance === 'sncf',
        }"
      >
        <div
          id="toolbar"
          class="d-flex ion-justify-content-center"
          :style="stickyToolbar ? 'height: 70px' : ''"
        >
          <img
            v-if="!noIconToolbar"
            class="ion-margin-bottom ion-margin-top"
            src="/assets/home.png"
            alt=""
          />
          <ion-title v-if="noIconToolbar">{{ name }}</ion-title>
          <ion-icon
            style="position: absolute; right: 16px; top: 16px"
            v-if="langs.length > 1"
            @click="showLangs()"
            size="large"
            icon="globe"
          ></ion-icon>
        </div>

        <div
          v-if="homeMessageDisplay"
          class="mc-st-information"
          style="padding: 10px"
          v-show="display"
        >
          <ion-icon
            class="mc-information-icon"
            name="close"
            v-on:click="closeInformation()"
          ></ion-icon>
          <div
            class="mc-information-text"
            v-html="$t('message.home.information')"
          ></div>
        </div>

        <div
          v-if="showModuleSelector && numberOfModule > 1"
          class="ion-padding-bottom d-flex justify-center"
        >
          <ion-segment
            v-if="this.appModule.CARPOOL"
            class="module-segment"
            value="carpool"
            mode="ios"
            @ionChange="moduleChanged($event)"
          >
            <ion-segment-button
              v-if="this.appModule.HITCHHIKING"
              value="hitchHiking"
              mode="ios"
            >
              <ion-label>{{ $t("Modules.hitchHiking") }}</ion-label>
            </ion-segment-button>
            <ion-segment-button value="carpool" mode="ios">
              <ion-label class="d-flex align-center">
                {{ $t("Modules.carpool") }}
                <ion-icon
                  v-if="instance == 'mobicoop'"
                  style="margin-left: 5px"
                  name="hourglass-outline"
                ></ion-icon>
              </ion-label>
            </ion-segment-button>
            <ion-segment-button
              v-if="this.appModule.SOLIDARYTRANSPORT"
              value="solidary"
              mode="ios"
            >
              <ion-label>{{ $t("Modules.solidary") }}</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div>
      </div>

      <UserHome />

      <ion-modal
        v-if="instance == 'mobicoop'"
        ref="modal"
        trigger="open-modal"
        :backdrop-dismiss="false"
        :is-open="isOpenNextClosureDialog"
        @ion-modal-did-dismiss="closeModal"
        style="--height: 350px"
      >
        <ion-header>
          <ion-toolbar style="--background: var(--ion-color-warning)">
            <ion-title class="bg-primary">Mobicoop Covoit’</ion-title>
            <ion-buttons slot="end">
              <ion-button @click="isOpenNextClosureDialog = false"
                >Passer</ion-button
              >
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <div v-if="!!!this.$store.state.userStore.user">
            <p>
              L’espace Covoit’ de cette application est en cours de remplacement
              par une nouvelle app’ <strong>Mobicoop Covoit’</strong> » plus
              rapide et plus moderne.
            </p>
            <p>Il sera définitivement fermé en novembre.</p>
            <p>
              <strong
                >Connectez-vous avec votre compte utilisateur Mobicoop ou
                inscrivez-vous dès maintenant sur Mobicoop Covoit’</strong
              >.
            </p>
          </div>
          <div v-if="!!this.$store.state.userStore.user">
            <p><strong>Fermeture prochaine de l’espace Covoit’</strong></p>
            <p>
              L’espace Covoit’ est en cours de remplacement depuis le 23 juillet
              par une nouvelle app’ « Mobicoop Covoit’ » plus rapide et plus
              moderne (vos identifiants de connexion restent les mêmes).<br />À
              partir de novembre, l’espace Covoit’ ne sera plus accessible.
            </p>
            <p>
              Plus d’informations sur la
              <a
                target="_blank"
                href="https://zammad.mobicoop.io/help/fr-fr/16-mobicoop-covoit"
                >FAQ !</a
              >.
            </p>
          </div>
          <p>
            <a style="width: 100%" :href="getNextUrl()" target="_blank">
              <ion-button class="mc-big-button" color="primary" expand="block">
                Découvrir la nouvelle application
              </ion-button>
            </a>
          </p>
        </ion-content>
      </ion-modal>

      <div class="mc-white-container">
        <ion-card
          v-if="appMobileVersion && appMobileVersion.homeMessage"
          class="home-info"
          color="warning"
        >
          <ion-card-content class="d-flex">
            <div style="font-size: 14px">
              {{ appMobileVersion.homeMessage }}
            </div>
          </ion-card-content>
        </ion-card>

        <SearchQuick ref="searchHomeComponent" />

        <!-- Prime -->
        <div
          v-if="isPrimeblockDisplayed"
          class="mc-block-action"
          v-bind:style="{ background: 'rgba(' + secondary + ', 0.4)' }"
        >
          <div
            class="mc-block-action-title"
            style="margin-bottom: 0px"
            v-bind:style="{ background: 'rgba(' + secondary + ', 1)' }"
          >
            <p class="d-flex align-center">
              <b>{{ $t(`Prime.title`) }}</b>
              <a
                v-if="!!primeInfoUrl"
                class="d-flex align-center"
                :href="primeInfoUrl"
                target="_blank"
                style="color: white; margin-left: 10px; font-size: 18px"
              >
                <ion-icon slot="icon-only" name="information-circle"></ion-icon>
              </a>
            </p>
          </div>
          <div style="padding: 10px">
            <p class="text-center">
              <b
                v-html="
                  !!eecInstance && eecInstance.available == false
                    ? $t(`Prime.closed`)
                    : $t(`Prime.description`)
                "
              ></b>
            </p>
            <div class="mc-block-action-container-button">
              <div
                class="mc-block-action-button pointer"
                v-bind:style="{ color: 'rgba(' + secondary + ', 1)' }"
                @click="$router.push('eec-incentive')"
              >
                {{ $t("Prime.description-follow") }}
              </div>
            </div>
          </div>
        </div>
        <!-- Prime -->

        <BlockAction
          v-if="instance === 'sncf'"
          :action="'experiment'"
          :color="'rgba(' + primary + ', 1)'"
          :colorBg="'rgba(' + primary + ', 0.4)'"
          :icon="''"
          @clickButton="redirectToExperiment()"
        />
        <BlockAction
          v-if="showCommunities"
          :action="'communities'"
          :color="'rgba(' + primary + ', 1)'"
          :colorBg="'rgba(' + primary + ', 0.4)'"
          :icon="''"
          @clickButton="redirectToCommunities()"
        />
        <BlockAction
          v-if="showEvents"
          :action="'events'"
          :color="'rgba(' + secondary + ', 1)'"
          :colorBg="'rgba(' + secondary + ', 0.4)'"
          :icon="''"
          @clickButton="redirectToEvents()"
        />
        <BlockAction
          v-if="showSolidarity"
          :action="solidaryType"
          :color="'rgba(' + success + ', 1)'"
          :colorBg="'rgba(' + success + ', 0.4)'"
          :icon="null"
          :secondButton="true"
          :instance="instance"
          @clickButton="
            solidaryType == 'solidarity'
              ? redirectToSolidarity()
              : redirectToMob()
          "
          @clickSecondButton="redirectToSolidarityPost()"
        />

        <div
          class="mc-download-app"
          v-if="
            isNotCapacitor &&
            appMobileVersion &&
            appMobileVersion.androidRecommendedLink &&
            appMobileVersion.iosRecommendedLink
          "
        >
          <div>
            <p class="text-center">
              <b>Retrouvez nos applications mobiles sur les stores</b>
            </p>
          </div>
          <ion-grid>
            <ion-row>
              <ion-col class="d-flex align-center" style="margin-right: 10px">
                <a
                  style="width: 100%"
                  :href="appMobileVersion.iosRecommendedLink"
                  target="_blank"
                  ><img
                    style="width: 100%"
                    src="/assets/download_appstore.svg"
                    alt=""
                /></a>
              </ion-col>
              <ion-col class="d-flex align-center" style="margin-left: 10px">
                <a
                  style="width: 100%"
                  :href="appMobileVersion.androidRecommendedLink"
                  target="_blank"
                  ><img
                    style="width: 100%"
                    src="/assets/download_googleplay.png"
                    alt=""
                /></a>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-if="showRelaypoints"
          v-on:click="redirectToRelaypoints()"
        >
          <ion-icon name="map" class="ion-padding-end"></ion-icon>
          {{ $t("HOME.relaypoints") }}
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToFAQ()"
        >
          {{ $t("HOME.FAQ") }}
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToCGU()"
        >
          {{ $t("HOME.CGU") }}
        </ion-button>

        <ion-button
          v-if="showCommunitiesArticle"
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToCommunitiesArticle()"
        >
          {{ $t("HOME.communities") }}
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToContact()"
        >
          {{ $t("HOME.contact") }}
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-if="showMob"
          v-on:click="redirectToPrime()"
        >
          {{ $t("HOME.prime") }}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          v-on:click="goToModalis()"
          v-if="instance == 'modalis'"
        >
          <img
            style="margin: 10px; height: calc(100% - 10px)"
            src="assets/modalis.png"
          />
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="$router.push('/article/15')"
          v-if="instance == 'sncf'"
        >
          En savoir plus
        </ion-button>

        <div v-if="partner" class="ion-margin text-center">
          <img class="partner-img" src="/assets/partner.png" alt="" />
        </div>

        <div class="text-center" v-if="version">
          <ion-text color="primary"
            ><small style="opacity: 0.75"
              >version {{ version }}</small
            ></ion-text
          >
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.home-statusbar {
  height: 0px !important;
  --border-width: 0px !important;
}

.safe-area {
  --padding-top: env(safe-area-inset-top);
}

.sticky {
  position: sticky;
  top: 0px;
  background: var(--ion-color-primary);
  z-index: 9999;
}
.home-info {
  margin: 0px;
  margin-bottom: 16px;
}

.background-grey {
  background-color: #f0f0f0;
}

.header-img-rezo {
  width: 150px;
  right: calc(50% - 75px);
  margin-right: 0px !important;
  position: fixed;
  top: 14px;
  z-index: 999999;
}

.plt-capacitor.plt-ios .header-img-rezo {
  top: 31px !important;
}

.mc-container {
  padding: 30px;
  //background-image: url("/assets/banner.png");
  background-repeat: no-repeat;
  // background-size: 100%;
  background-size: cover;
  background-position: center;
  margin-bottom: -10px;
  position: relative;
}

.img-background {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.mc-container-right {
  background-position: center !important;
}

.mc-download-app {
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 20px;
  background: rgba(var(--ion-color-primary-rgb), 0.4);

  p {
    margin: 0px;
    margin-bottom: 20px;
  }
}

.partner-img {
  width: 75%;
  object-fit: contain;
  // max-height: 100px;
}

.mc-home-header {
  .mc-home-log {
    display: flex;
    align-items: center;

    img {
      // width: 26px;
      height: 48px;
      // margin-top: 6px;
      // margin-bottom: 6px;
    }

    h1 {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }

    p {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }

    .mc-home-switch {
      margin-left: auto;
    }
  }

  .toolbar-background {
    --background: var(--ion-color-primary) !important;
  }
}
</style>

<script>
import UserHome from "./Components/UserHome.component";
import BlockAction from "./Components/BlockAction.component";
import ModuleModal from "../../Shared/Component/ModuleModal.component";
import SearchQuick from "../Shared/Components/SearchQuick.component";
import BannerCompletedAction from "../Gamification/BannerCompletedAction.vue";

import { isPlatform } from "@ionic/core";
import RelaypointsMap from "../Shared/Components/RelaypointsMap.component";
import { Device } from "@capacitor/device";
import { actionSheetController, popoverController } from "@ionic/vue";

export default {
  name: "home",
  components: {
    UserHome,
    BlockAction,
    SearchQuick,
    BannerCompletedAction,
    RelaypointsMap,
  },
  data() {
    return {
      instance: process.env.VUE_APP_INSTANCE,
      name: process.env.VUE_APP_NAME,
      title: process.env.VUE_APP_TITLE,
      subtitle: process.env.VUE_APP_SUBTITLE,
      primary: "",
      secondary: "",
      success: "",
      partner: JSON.parse(process.env.VUE_APP_PARTNER),
      showModuleSelector: JSON.parse(process.env.VUE_APP_SHOW_MODULE),
      showSolidarity: JSON.parse(process.env.VUE_APP_SHOW_SOLIDARITY_TRANSPORT),
      appModule: JSON.parse(process.env.VUE_APP_MODULE),
      showEvents: JSON.parse(process.env.VUE_APP_SHOW_EVENTS),
      showCommunities: JSON.parse(process.env.VUE_APP_SHOW_COMMUNITIES),
      showRelaypoints: JSON.parse(process.env.VUE_APP_RELAYPOINTS),
      stickyToolbar: JSON.parse(process.env.VUE_APP_STICKY_TOOLBAR),
      noIconToolbar: JSON.parse(process.env.VUE_APP_NO_ICON_TOOLBAR),
      noTextToolbar: JSON.parse(process.env.VUE_APP_NO_TEXT_TOOLBAR),
      showCommunitiesArticle: JSON.parse(
        process.env.VUE_APP_CREATE_COMMUNITY_ARTICLE
      ),
      showMob: JSON.parse(process.env.VUE_APP_MOB),
      primeInfoUrl: process.env.VUE_APP_MOB_INFO_URL,
      langs: JSON.parse(process.env.VUE_APP_LANGS),
      isNotCapacitor: !isPlatform(window.document.defaultView, "capacitor"),
      solidaryLink: process.env.VUE_APP_SOLIDARITY_LINK,
      homeMessageDisplay: JSON.parse(process.env.VUE_APP_MESSAGE_HOME),
      version: null,
      selectedLanguage: null,
      displayedLanguage: null,
      display: true,
      LMarker: null,
      showMap: false,
      solidaryType: JSON.parse(process.env.VUE_APP_HELP_MOB)
        ? "mob"
        : "solidarity",
      eecInstance: null,
      isOpenNextClosureDialog: true,
    };
  },
  created() {
    this.primary = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-primary-rgb");
    this.secondary = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-secondary-rgb");

    this.success = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-success-rgb");

    const l = localStorage.getItem("language");
    this.displayedLanguage = !!l ? l : "fr";
    this.$i18n.locale = !!l ? l : "fr";

    if (this.showMob) {
      this.getEecInstance();
    }
    // this.$store.state.userStore.user.language.code;
  },
  ionViewWillEnter() {
    this.$refs.searchHomeComponent.onIonViewWillEnter();
  },
  computed: {
    numberOfModule() {
      return Object.values(this.appModule).filter((item) => item == true)
        .length;
    },
    appMobileVersion() {
      return this.$store.state.appStore.version;
    },
    isPrimeblockDisplayed() {
      return this.showMob && this.eecInstance && this.eecInstance.available;
    },
  },
  mounted() {
    this.getVersion();
    // caching for crawlers
    setTimeout(() => {
      window.prerenderReady = true;
    }, 1000);
    this.getLocale();
  },
  methods: {
    getEecInstance() {
      this.$store
        .dispatch("eec_instance")
        .then((res) => {
          this.eecInstance = res;
        })
        .catch((err) => {});
    },
    getLocale: function () {
      this.$i18n.locale = this.displayedLanguage;
    },
    closeWelcome: function () {
      this.seeWelcome = false;
    },
    closeInformation: function () {
      this.display = false;
    },
    redirectToCommunities: function () {
      this.$router.push({
        name: !!this.$store.state.userStore.user
          ? "communities"
          : "allcommunities",
      });
    },
    redirectToExperiment: function () {
      this.$router.push({
        name: "article",
        params: { id: 15 },
      });
    },
    redirectToEvents: function () {
      this.$router.push({ name: "carpool-events" });
    },

    redirectToFAQ: function () {
      if (this.instance == "mobicoop") {
        // window.open('http://support.mobicoop.fr', '_system')
        this.$router.push({
          name: "article",
          params: { id: 10 },
        });
      } else if (this.instance == "sncf") {
        window.open(this.$t("Link.faq"), "_blank");
      } else {
        this.$router.push({
          name: "article",
          params: { id: 10 },
        });
      }
    },

    redirectToCGU: function () {
      /*
      if (this.instance == 'mobicoop') {
        window.open('http://support.mobicoop.fr', '_system')
      } else {

      }
       */
      this.$router.push({
        name: "article",
        params: { id: 1 },
      });
    },

    redirectToCommunitiesArticle: function () {
      this.$router.push({
        name: "article",
        params: { id: 12 },
      });
    },

    redirectToPrime: function () {
      this.$router.push({
        name: "article",
        params: { id: 32 },
      });
    },

    redirectToContact: function () {
      if (this.instance == "mobigo") {
        window.open(
          "https://mobigo.manett-ondemand.cityway.fr/MOBIGO/Claim",
          "_system"
        );
      } else if (this.instance == "oise") {
        window.open("https://www.oise-mobilite.fr/contact", "_system");
      } else {
        this.$router.push({ name: "carpool-contact" });
      }
    },

    redirectToSolidarity: function () {
      if (this.instance == "mobilaude") {
        this.$router.push({ name: "article", params: { id: 8 } });
      } else if (this.solidaryLink == "") {
        this.$router.push({ name: "carpool.solidary.home.request" });
      } else {
        this.$router.push({ name: "carpool-solidarity" });
      }
    },

    redirectToMob: function () {
      this.$router.push({ name: "mob-help" });
    },

    redirectToSolidarityPost: function () {
      this.$router.push({ name: "post-carpool", query: { solidarity: true } });
    },

    redirectToRelaypoints: function () {
      this.$router.push({ name: "carpool-relaypoints" });
    },

    goToModalis: function () {
      window.open("https://modalis.fr", "_blank");
    },

    showModule: async function (ev) {
      const modal = await popoverController.create({
        component: ModuleModal,
        componentProps: {
          propsData: {
            appModule: this.appModule,
            router: this.$router,
          },
        },
        event: ev,
        translucent: true,
        cssClass: "modulePopover",
      });

      await modal.present();
    },
    async getVersion() {
      if (isPlatform(window.document.defaultView, "capacitor")) {
        let info = await Device.getInfo();
        this.version = info.appVersion;
      }
    },
    async showLangs() {
      const buttons = [];
      this.langs.forEach((item) => {
        buttons.push({
          text: this.$t("Langs." + item),
          handler: () => {
            this.setLang(item);
          },
        });
      });
      buttons.push({
        text: this.$t("Commons.cancel"),
        role: "cancel",
      });

      const actionSheet = await actionSheetController.create({
        header: this.$t("Langs.change"),
        buttons: buttons,
      });
      return actionSheet.present();
    },
    redirectHitchHiking() {
      this.$router.push({ name: "hitchHiking.home" });
    },
    setLang(item) {
      this.selectedLanguage = item;
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem("language", this.selectedLanguage);

      const payload = {
        userId: this.$store.getters.userId,
        language: {
          code: item,
        },
      };

      if (this.$store.getters.userId) {
        this.$store
          .dispatch("updateLanguage", payload)
          .then(() => {
            this.$store.commit("user_update_language_success");
          })
          .catch((error) => {
            this.presentToast(this.$t("Commons.error"), "danger");
          });
      }
    },
    moduleChanged(event) {
      let link;
      switch (event.detail.value) {
        case "carpool":
          link = "carpoolsHome";
          break;
        case "hitchHiking":
          link = "hitchHiking.home";
          break;
        case "solidary":
          link = "solidaryTransport";
          break;
      }

      this.$router.push({ name: link });
    },
    getNextUrl() {
      if (isPlatform(window.document.defaultView, "ios")) {
        return "https://apps.apple.com/fr/app/mbc-next/id6737623414";
      } else if (isPlatform(window.document.defaultView, "android")) {
        return "https://play.google.com/store/apps/details?id=fr.mobicoop.next";
      } else {
        return "https://m.next.mobicoop.fr/tabs/search";
      }
    },
  },
};
</script>
